var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawInstantAnalysisVm8XGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 799.258,
    height: 645.667,
    viewBox: "0 0 799.258 645.667",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a-58",
    x1: 146.593,
    y1: 1,
    x2: 146.593,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-358.764 -257.99)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.381,
    cy: 5.362,
    rx: 5.381,
    ry: 5.362,
    transform: "translate(955.754 421.33)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.381,
    cy: 5.362,
    rx: 5.381,
    ry: 5.362,
    transform: "translate(466.772 421.33)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.381,
    cy: 5.362,
    rx: 5.381,
    ry: 5.362,
    transform: "translate(882.749 372.893)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.381,
    cy: 5.362,
    rx: 5.381,
    ry: 5.362,
    transform: "translate(602.595 334.012)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.381,
    cy: 5.362,
    rx: 5.381,
    ry: 5.362,
    transform: "translate(679.814 307.109)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.381,
    cy: 5.362,
    rx: 5.381,
    ry: 5.362,
    transform: "translate(607.977 257.99)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(753.489 263.352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.841,321.939c-21.962-5.467-40.817-16.212-55.557-33.951a4.976,4.976,0,0,1-1.65-6.833l25.64-41.958a4.976,4.976,0,0,1,6.833-1.649L630.665,271.5a4.976,4.976,0,0,1,1.649,6.833l-25.64,41.958A4.976,4.976,0,0,1,599.841,321.939Z",
    transform: "translate(-541.907 -227.452)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.891,308.331c-11.563-1.262-23.581-10.5-35.717-21.827a4.66,4.66,0,0,1-1.545-6.4l22.036-36.059a4.661,4.661,0,0,1,6.4-1.545L625.5,272.712a4.66,4.66,0,0,1,1.545,6.4L613.4,301.45A20.759,20.759,0,0,1,584.891,308.331Z",
    transform: "translate(-541.77 -227.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.471,
    cy: 15.415,
    rx: 15.471,
    ry: 15.415,
    transform: "translate(26.305 33.765)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,270.751c25.094-7.8,51.959.635,77.191-6.563a52.324,52.324,0,0,0,16.217-7.616,100.766,100.766,0,0,0,11.8-10.5c7.59-7.507,15.833-15.39,27.237-15.3,15.017.115,26.547,11.269,36.556,21.119,1.415,1.392,3.6-.785,2.179-2.179-9.2-9.051-19.135-18.6-32.226-21.3a29.739,29.739,0,0,0-17.58,1.46,45.9,45.9,0,0,0-13.064,8.933c-4.031,3.7-7.75,7.723-11.836,11.362a49.271,49.271,0,0,1-14.519,9.164c-11.567,4.606-24.255,5.162-36.558,5.028-15.444-.168-31.256-1.22-46.218,3.429-1.888.587-1.082,3.562.819,2.971Z",
    transform: "translate(-540.492 -227.699)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.315,231.088l7.714,13.6,3.733,6.58c.663,1.169,1.345,2.33,1.991,3.509.4.724,1.263,2.031.436,2.717a4.019,4.019,0,0,1-2.345.366c-1.36,0-2.72-.028-4.08-.041l-7.65-.078-15.81-.16a1.542,1.542,0,0,0,0,3.081c9.178.093,18.362.287,27.541.279a6.586,6.586,0,0,0,4.5-1.232,4.285,4.285,0,0,0,.817-4.939,46.936,46.936,0,0,0-3.115-5.715l-3.359-5.922-7.714-13.6a1.542,1.542,0,0,0-2.661,1.555Z",
    transform: "translate(-536.299 -227.669)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.072,263.625h-70.9a2.954,2.954,0,0,1,0-5.909h70.9a2.954,2.954,0,1,1,0,5.909Z",
    transform: "translate(-535.095 -226.885)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.072,309.953h-70.9a2.954,2.954,0,0,1,0-5.909h70.9a2.954,2.954,0,1,1,0,5.909Z",
    transform: "translate(-535.095 -242.107)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.674,286.789H796.17a2.954,2.954,0,0,1,0-5.909h140.5a2.954,2.954,0,0,1,0,5.909Z",
    transform: "translate(-535.095 -234.496)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(724.656 394.914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.841,386.939c-21.962-5.467-40.817-16.212-55.557-33.951a4.976,4.976,0,0,1-1.649-6.833l25.64-41.958a4.976,4.976,0,0,1,6.833-1.649L720.665,336.5a4.976,4.976,0,0,1,1.649,6.833l-25.64,41.958A4.976,4.976,0,0,1,689.841,386.939Z",
    transform: "translate(-631.907 -301.82)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.891,373.331c-11.563-1.262-23.581-10.5-35.717-21.827a4.66,4.66,0,0,1-1.545-6.4l22.036-36.059a4.661,4.661,0,0,1,6.4-1.545L715.5,337.712a4.661,4.661,0,0,1,1.545,6.4L703.4,366.45a20.759,20.759,0,0,1-28.506,6.881Z",
    transform: "translate(-631.77 -301.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.471,
    cy: 15.415,
    rx: 15.471,
    ry: 15.415,
    transform: "translate(30.054 23.315)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.636,405.873h-70.9a2.954,2.954,0,0,1,0-5.909h70.9a2.954,2.954,0,0,1,0,5.909Z",
    transform: "translate(-628.387 -299.16)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.636,452.2h-70.9a2.954,2.954,0,0,1,0-5.909h70.9a2.954,2.954,0,0,1,0,5.909Z",
    transform: "translate(-628.387 -314.338)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.238,429.037h-140.5a2.954,2.954,0,0,1,0-5.909h140.5a2.954,2.954,0,1,1,0,5.909Z",
    transform: "translate(-628.387 -306.749)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.62,339.89l53.014,40,15.089,11.384c1.583,1.194,3.12-1.48,1.555-2.661l-53.014-40-15.089-11.384c-1.583-1.194-3.12,1.48-1.555,2.661Z",
    transform: "translate(-630.794 -300.869)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.545,392.919a94.531,94.531,0,0,0,36.945,9.221,1.556,1.556,0,0,0,1.486-1.95l-8.21-32.953c-.479-1.923-3.452-1.108-2.971.819L753,401.008l1.486-1.95a90.706,90.706,0,0,1-35.389-8.8c-1.78-.853-3.344,1.8-1.555,2.661Z",
    transform: "translate(-629.607 -300.077)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(358.764 263.352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.841,412.939c-21.962-5.467-40.817-16.212-55.557-33.951a4.976,4.976,0,0,1-1.65-6.833l25.64-41.958a4.976,4.976,0,0,1,6.833-1.649L649.665,362.5a4.976,4.976,0,0,1,1.649,6.833l-25.64,41.958a4.976,4.976,0,0,1-6.833,1.649Z",
    transform: "translate(-452.424 -327.82)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.891,399.331c-11.563-1.262-23.581-10.5-35.717-21.827a4.66,4.66,0,0,1-1.545-6.4l22.036-36.059a4.661,4.661,0,0,1,6.4-1.545L644.5,363.712a4.661,4.661,0,0,1,1.545,6.4L632.4,392.45a20.759,20.759,0,0,1-28.506,6.881Z",
    transform: "translate(-452.288 -327.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.471,
    cy: 15.415,
    rx: 15.471,
    ry: 15.415,
    transform: "translate(134.779 25.427)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.143,456.116h-70.9a2.954,2.954,0,0,1,0-5.909h70.9a2.954,2.954,0,0,1,0,5.909Z",
    transform: "translate(-455.287 -324.503)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.143,502.444h-70.9a2.954,2.954,0,0,1,0-5.909h70.9a2.954,2.954,0,0,1,0,5.909Z",
    transform: "translate(-455.287 -339.681)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.745,479.28h-140.5a2.954,2.954,0,0,1,0-5.908h140.5a2.954,2.954,0,0,1,0,5.909Z",
    transform: "translate(-455.287 -332.092)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.922,366.912l-38.094,54.48-10.737,15.355c-1.139,1.629,1.531,3.17,2.661,1.555l38.094-54.48,10.737-15.355C604.721,366.839,602.051,365.3,600.922,366.912Z",
    transform: "translate(-452.671 -326.779)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.02,412.716a93.626,93.626,0,0,0-7.815,37.141,1.556,1.556,0,0,0,1.95,1.486l32.723-9.479a1.542,1.542,0,0,0-.819-2.971l-32.723,9.479,1.95,1.486a89.858,89.858,0,0,1,7.394-35.586c.783-1.8-1.871-3.371-2.661-1.555Z",
    transform: "translate(-452.958 -325.541)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558.38 383.616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.4,798.223a.476.476,0,0,0-.1.051c1.222-2.64,2.362-5.31,3.4-8.022.123-.318.236-.647.359-.965-.01.082-.01.164-.021.257-.031.514-.072,1.027-.113,1.551-.062.811-.113,1.633-.123,2.455-.01.257-.01.5-.01.76a15.027,15.027,0,0,0,.308,2.979h-.041c-.257.021-.493.031-.74.072a10.05,10.05,0,0,0-2.8.8.608.608,0,0,0-.113.062Z",
    transform: "translate(-218.59 -307.995)",
    fill: "url(#a-58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.28,405.907c.11,4.289,1.563,8.444,1.791,12.725-12.631.628-25.09-5.5-37.6-3.621,3.5-2.262,5.365-6.339,6.465-10.353a42.935,42.935,0,0,0,1.233-15.907,7.007,7.007,0,0,0-.157-.88c-.464-2.1-1.665-5.067-1.343-6.716.424-2.184,2.482-1.752,4.336-1.626a162.429,162.429,0,0,1,16.857,2.176c1.453.251,15.608,3.786,15.82,3.417a66.618,66.618,0,0,0-6.127,12.623A24.609,24.609,0,0,0,296.28,405.907Z",
    transform: "translate(-219.019 -319.104)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.625,393.008a18.464,18.464,0,0,1-3.857,3.888c-.958.785-1.94,1.587-2.969,2.309a12.733,12.733,0,0,1-6.315,2.569c-3.009.2-9.395-1.563-11.264-4.14a7.468,7.468,0,0,1-1.076-4.313,19.84,19.84,0,0,1,1.037-6.033,33.623,33.623,0,0,1,4.87-8.813c2.176-3.024,4.6-6,7.832-7.832a30.384,30.384,0,0,1,3.331-1.532c1.964-.8,3.92-1.61,5.884-2.412a2.841,2.841,0,0,1,1.068-.283c1.579.016,1.87,2.427.974,3.731-1.791,2.624-5.821,3.354-6.952,6.331a4.513,4.513,0,0,1,4.195,3.252,2.3,2.3,0,0,0,.566,1.312c.518.416,1.328.181,1.917.495,1.045.558.589,2.113.7,3.291a15.4,15.4,0,0,0,1.076,2.961,6.292,6.292,0,0,1-1.013,5.216Z",
    transform: "translate(-215.45 -319.456)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.432,811.5c.972-.972,2.561-.806,3.919-.592a145.366,145.366,0,0,0,22.032,1.782c.924-4.511-1.758-8.9-2.622-13.418a12.1,12.1,0,0,0-.873-3.393c-1.039-1.994-3.383-2.906-5.583-3.37-3.97-.837-10.177-2.315-12.394,1.7C249.251,799.029,248.4,806.143,247.432,811.5Z",
    transform: "translate(-219.372 -307.934)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.282,794.955c-2.993,2.042-6.708,2.679-10.306,3.142s-7.305.809-10.565,2.412c-2.812,1.39-5.184,3.668-8.162,4.666a17,17,0,0,1-8.476.134c-3.346-.628-6.913-1.846-8.719-4.737-1.61-2.569-1.438-5.829-1.218-8.853q.389-5.125.762-10.267a4.889,4.889,0,0,1,.636-2.482c2.419-3.527,8.3,1.477,11.453,1.469,4.988-.008,10.345-2.71,13.943-6.017a4.233,4.233,0,0,1,1.084-.817c1.422-.636,2.844.542,4.108,1.571.141.118.283.236.424.346,2.914,2.309,6.826,2.781,10.424,3.716s7.462,2.82,8.578,6.371a5.419,5.419,0,0,1,.173.683C332.073,789.559,330.086,793.039,327.282,794.955Z",
    transform: "translate(-218.498 -308.425)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.788,577.971a44.97,44.97,0,0,0,6.163,33.181c1.714,2.655,3.721,5.147,5.01,8.033a36.507,36.507,0,0,1,1.955,6.366l5.552,22.98c1.5,6.2,3.008,12.527,2.558,18.894-.314,4.436-1.432,9.424,1.3,12.931a9.528,9.528,0,0,1,1.652,2.266,5.736,5.736,0,0,1,.027,2.986c-2.809,16.684-4.892,34.126.182,50.266,4.6,14.629,4.861,30.838,8.771,45.666.484,1.836,1.038,3.772,2.429,5.064a7.962,7.962,0,0,0,3.641,1.73c5.762,1.371,11.847-.235,17.22-2.725,3.777-1.75,7.842-4.819,7.519-8.969-.154-1.974-1.307-3.7-2.089-5.523-1.535-3.567-1.658-7.552-2.073-11.414-1.04-9.7-4.029-19.058-6.289-28.545s-3.794-19.4-1.883-28.962a253.354,253.354,0,0,1,18.633-57.32,6.914,6.914,0,0,1,1.707-2.567,17.64,17.64,0,0,0,2.416-1.649,7.288,7.288,0,0,0,1.105-3.005c.84-3.027,3.337-5.26,5.01-7.918,4.225-6.712,2.886-15.316,2.73-23.246-.152-7.711.958-15.494-.306-23.1s-5.623-15.386-12.958-17.77c-3.634-1.181-7.562-.913-11.364-.537C287.265,567.075,267.692,570.734,248.788,577.971Z",
    transform: "translate(-219.36 -314.081)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.894,626.237a48.166,48.166,0,0,1-1.013,8.916q-5.326,29.869-11.351,59.613c-.353,1.72-.7,3.441-1.163,5.129a41.6,41.6,0,0,1-7.69,15.129c-16.74,20.863-18.185,51.161-27.266,76.321-.613,1.7-1.225,3.409-1.877,5.09a127.133,127.133,0,0,1-5.6,12.5,3.573,3.573,0,0,1-1.155,1.492,3.425,3.425,0,0,1-1.822.354,53.2,53.2,0,0,1-23.589-5.365,4.885,4.885,0,0,1-2.506-2.082,5.034,5.034,0,0,1-.267-2.4c.251-4.988.558-10.157,2.938-14.54a31.025,31.025,0,0,1,5.813-7.046c.707-15.655,2.255-31.342,5.7-46.628,1.767-7.816,3.951-15.718,8.491-22.324,3.346-4.878,8.146-9.693,7.557-15.577-.259-2.584-1.343-5.8.762-7.321.919-.668,2.278-.754,2.9-1.7a3.233,3.233,0,0,0,.409-1.461,36.074,36.074,0,0,0-.746-12.074,63.681,63.681,0,0,1-1.8-7.871c-.267-2.687.189-5.593,1.98-7.6.11-5.373-.039-10.95.071-16.315a30.257,30.257,0,0,0-.754-9.112c-.408-1.406-1.029-2.749-1.343-4.187-1.123-5.161,1.681-11.343-1.657-15.435-1.39-1.7-3.535-2.545-5.357-3.771-3.637-2.427-6.025-6.4-7.353-10.573a58.353,58.353,0,0,1-2.082-12.945,13.324,13.324,0,0,1-.031-2.8,5.124,5.124,0,0,1,.377-1.4c1.037-2.333,3.826-3.236,6.308-3.833a204.263,204.263,0,0,1,48.168-5.632c6-4.085,9.379-2.624,11.924,1.7a44.734,44.734,0,0,1,3.393,8.287c1.163,3.511,1.233,23.165,2.364,26.692C335.088,612.059,330.839,621.422,330.894,626.237Z",
    transform: "translate(-219.423 -313.982)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.169,
    cy: 29.169,
    r: 29.169,
    transform: "translate(42.415 20.353)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.37,415.624c-1.272,1.471-2.978,3.093-4.864,2.619a6.646,6.646,0,0,1-1.893-1.013c-3.363-2.167-7.49-2.676-11.446-3.272a168.878,168.878,0,0,1-23.571-5.3,24.042,24.042,0,0,0-6.972-1.418c-4.944.026-9.325,3.312-12.424,7.165s-5.293,8.361-8.333,12.26c-2.166,2.778-4.746,5.226-6.768,8.109-5.107,7.28,15.579,93.857,15.3,95.316-1.937,13.776-2.955,52.124-2.1,59.19a108.265,108.265,0,0,1,28.424-6.753c6.268-.615,12.654-.692,18.7-2.452,3.777-1.1,7.359-2.839,11.193-3.715a51.6,51.6,0,0,1,9.438-.964c6.99-.282,14.029-.561,20.948.469.56.083,1.243.128,1.578-.328a1.476,1.476,0,0,0,.21-.825A13.948,13.948,0,0,0,334,567.288c-.882-1.557-2.108-3.08-2.074-4.868.064-.834-1.739-109.843-4.327-114.491-3.012-5.409-6.066-10.93-7.282-17-.8-4.018-.777-8.156-1.353-12.214a5.334,5.334,0,0,0-1.031-2.852c-.988-1.12-2.66-1.28-4.152-1.233a18.379,18.379,0,0,0-5.411,1Z",
    transform: "translate(-219.81 -318.35)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.02,461.57c1.775,2.214,3.626,4.49,6.144,5.8,2.9,1.5,6.311,1.538,9.575,1.469a228.8,228.8,0,0,0,40.012-4.4c1.5-.259,17.6-10.257,20.9-14.462,3.926-5.078,13.8-37.669,14.148-39.526a15.121,15.121,0,0,1,4.629-8.326,3.036,3.036,0,0,0,1.1-1.463,2.358,2.358,0,0,0-.262-1.426c-1.343-2.992-4.414-4.921-7.6-5.7a32.614,32.614,0,0,0-9.791-.389,22.877,22.877,0,0,0-3.207.852c-2.588,7.011-20.619,39.474-21.562,39.425-2.578.159-8.144,1.1-10.48,0-2.654-1.244-11.355-1.294-11.819-1.548-1.052-.613-10.512-4.711-11.745-4.579.777-.692-17.137-5.2-18.372-7.35-.438-.762-.523-1.8-1.268-2.263a2.447,2.447,0,0,0-1.627-.189,15.908,15.908,0,0,0-4.922,1.494c-2.526,9.88-1.2,20.14.724,30.155a26.6,26.6,0,0,0,5.422,12.43Z",
    transform: "translate(-217.718 -318.737)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.748,408.43c-3.129-1.948-6.813-2.774-10.439-3.436a22,22,0,0,0-6.642-.478c-2.053.256-4.024,1.049-6.09,1.164-2.9.162-5.68-1.015-8.482-1.781s-6.037-1.06-8.4.635a3.626,3.626,0,0,1-1.827.971,3.2,3.2,0,0,1-1.889-.926,10.762,10.762,0,0,0-13.413.707c-5.348,5.015-4.743,14.813-11.011,18.617-1.728,1.048-3.936,1.6-4.945,3.354a12.387,12.387,0,0,1-.853,1.613,4.369,4.369,0,0,1-1.507,1.074,29.279,29.279,0,0,0-5.166,2.97,7.388,7.388,0,0,0-2.973,4.984,9.391,9.391,0,0,0,.913,4.192A39.332,39.332,0,0,0,259.25,466.53a6.05,6.05,0,0,0,4-1.25,7.556,7.556,0,0,0,1.4-2.312c2.946-6.178,8.481-10.739,11.995-16.613,2.094-3.5,3.439-7.416,5.619-10.864,3.305-5.227,8.331-9.088,13.251-12.835,2.774-2.113,5.863-4.33,9.348-4.182,3.106.132,5.366.3,4.227-3.511a12.2,12.2,0,0,0-5.349-6.533Z",
    transform: "translate(-220.113 -318.477)",
    fill: "#cba864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.748,408.43c-3.129-1.948-6.813-2.774-10.439-3.436a22,22,0,0,0-6.642-.478c-2.053.256-4.024,1.049-6.09,1.164-2.9.162-5.68-1.015-8.482-1.781s-6.037-1.06-8.4.635a3.626,3.626,0,0,1-1.827.971,3.2,3.2,0,0,1-1.889-.926,10.762,10.762,0,0,0-13.413.707c-5.348,5.015-4.743,14.813-11.011,18.617-1.728,1.048-3.936,1.6-4.945,3.354a12.387,12.387,0,0,1-.853,1.613,4.369,4.369,0,0,1-1.507,1.074,29.279,29.279,0,0,0-5.166,2.97,7.388,7.388,0,0,0-2.973,4.984,9.391,9.391,0,0,0,.913,4.192A39.332,39.332,0,0,0,259.25,466.53a6.05,6.05,0,0,0,4-1.25,7.556,7.556,0,0,0,1.4-2.312c2.946-6.178,8.481-10.739,11.995-16.613,2.094-3.5,3.439-7.416,5.619-10.864,3.305-5.227,8.331-9.088,13.251-12.835,2.774-2.113,5.863-4.33,9.348-4.182,3.106.132,5.366.3,4.227-3.511a12.2,12.2,0,0,0-5.349-6.533Z",
    transform: "translate(-220.113 -318.477)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.367,820.5c-2.113,1.972-5.019,2.836-7.839,3.448a141.3,141.3,0,0,1-19.512,2.411c-2.121.157-4.25.322-6.371.487-6.221.471-12.451.951-18.7.974a128.932,128.932,0,0,1-22.992-1.987,1.951,1.951,0,0,1-2.1-2.333c.135-7.771,5.327-13.807,7.072-21.381.723-3.111,2.056,2.167,2.307,2.457,1.547,1.76,2.718,2.569,5.067,2.694,6.418.354,13.605-3.551,18.7-7.023a23.935,23.935,0,0,1,3.464-2.144,10.193,10.193,0,0,1,2.8-.8,16.932,16.932,0,0,1,9.544,1.932c3.833,1.9,7.2,4.635,10.989,6.591a30.891,30.891,0,0,0,9.85,3.119c3.472.479,7.62.707,9.4,3.715a.029.029,0,0,1,.008.024C321.533,815.173,320.472,818.535,318.367,820.5Z",
    transform: "translate(-219.552 -307.78)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,372.856a5.39,5.39,0,0,0,2.015.75A6.5,6.5,0,0,0,265,372.8Z",
    transform: "translate(-219.097 -319.283)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.578,19.409a19.973,19.973,0,0,0-10.945-5.743c-4.058-.873-8.51-1.144-11.757-3.689-3.69-2.939-5.313-8.523-9.839-9.765a10.786,10.786,0,0,0-5.891.467A38.124,38.124,0,0,0,12.7,12.977,15.793,15.793,0,0,1,8.456,17.22a30.716,30.716,0,0,0-2.927,1.427,7.968,7.968,0,0,0-2.386,3.111A30.24,30.24,0,0,0,1.027,43c1.131,4.194,3.173,8.08,4.378,12.3s6.779,12.243,8.083,10.25S16.465,61.7,17.178,59.4c1.392-4.524.135-9.076,3.674-12.218,2.189-1.943,6.149-3.247,7.637-.738.59.972.553,2.2,1.058,3.21,1,1.968,3.874,2.361,5.78,1.23a8.867,8.867,0,0,0,3.616-5.362c2.865-9.691,7.748-15.791,18.115-11.646,3.862,1.55,8.412,2.595,12.126-.061C74.079,30.317,73.083,23.393,69.578,19.409Z",
    transform: "translate(28.806 8.84) rotate(-7)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawInstantAnalysisVm8XGold);
export default __webpack_public_path__ + "static/media/undraw_instant-analysis_vm8x_gold.228846e104ab688695614e332e70b332.svg";
export { ForwardRef as ReactComponent };